import styled from 'styled-components';


// Styled Components
const TablesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px 0;
  margin-bottom: 40px;
`;

const TablesWrapper = styled.div`
  width: 850px;
  display: flex;
  justify-content: space-between;
`;

const TableBox = styled.div`
  width: 320px;
  height: auto;
  border-radius: 8px;
  border: 1px solid #E0E0E0;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin: 0 20px;
`;

const TableTitle = styled.div`
  padding: 15px;
  border-bottom: 1px solid #E0E0E0;
`;

const TableHeader = styled.div`
  display: flex;
  padding: 10px 15px;
  border-bottom: 1px solid #E0E0E0;
  background-color: #F8F9FA;
  font-weight: 700;
  font-size: 13px;
  color: rgba(67, 67, 67, 0.7);
`;

const TableRow = styled.div`
  display: flex;
  padding: 16px 15px;
  border-bottom: 1px solid #E0E0E0;
  font-weight: 500;
  font-size: 15px;
  color: rgba(67, 67, 67, 0.7);
`;

const NameCell = styled.div`
  flex: 2;
`;

const CountCell = styled.div`
  flex: 1;
  text-align: right;
`;

export { TablesContainer, TablesWrapper, TableBox, TableTitle, TableHeader, NameCell, CountCell, TableRow };
